import { Link } from "react-router-dom"

function Add({ title, url, image }) {

    return (
        <Link to={url} target="_blank" className="height-30p no-text-decoration white-color-background padding-2p top-margin-10 border-radius-10 light-shaddow">
            <p className="text-gray-dark text-center padding-1p margin-auto">{title}</p>
            <img src={image.imageName} className='article-card-img height-80p' alt={image.altText} />
        </Link>
    )
}

export default Add